import { HttpClient } from '@angular/common/http';
import { Injectable, ɵɵresolveBody } from '@angular/core';
import { Friend } from 'src/app/models/friend.model';
import { Global } from '../../global/global';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  private chatFriend!: Friend;

  constructor(
   private httpClient: HttpClient
  ) { }

  public getChatId(receipendId: string){
    return this.httpClient.get(Global.BASE_API_URL + "/messages/" + receipendId + "/getChatId", {responseType: 'text'})
  }

  public setChatFriend(chatFriend: Friend){
    this.chatFriend = chatFriend;
  }

  public getChatFriend(){
    return this.chatFriend;
  }


}
